import React from 'react';

import { Control } from '@vlabs/uikit';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath } from 'react-router-dom';

interface CardLinkProps {
  cardId?: string;
  testId?: string;
}

function CardLink({
  cardId = undefined,
  testId = undefined,
}: CardLinkProps): React.JSX.Element {
  if (!cardId) return <React.Fragment>-</React.Fragment>;

  return (
    <Control.Link
      data-testid={testId}
      to={generatePath(routes.externalId.read, { externalId: cardId })}
    >
      {cardId}
    </Control.Link>
  );
}

export { CardLink };
